import {
  AuResourceName,
  AuPolicy,
  checkAuthorization,
} from "@arrowsup/platform-dtos";

/**
 * convenience type for CRUD permissions
 */
export type CrudPermissions = {
  create: boolean;
  read: boolean;
  update: boolean;
  delete: boolean;
};

/**
 * For a given auResourceName and set of permissions,
 * look up which CRUD actions are allowed
 * @param auResourceName The resource name
 * @param permissions the users permissions
 * @returns which CRUD operations are allowed
 */
export const getPermissions = (
  auResourceName: AuResourceName,
  permissions: AuPolicy[]
): CrudPermissions => {
  return {
    create: checkAuthorization(auResourceName, permissions, "create"),
    read: checkAuthorization(auResourceName, permissions, "read"),
    update: checkAuthorization(auResourceName, permissions, "update"),
    delete: checkAuthorization(auResourceName, permissions, "delete"),
  };
};

/**
 * Get a record of all AuResourceNames to their CrudPermissions for the
 * current user
 * @param permissions The user's permissions
 * @returns a Record from AuResourceName to CrudPermissions
 */
export const getAllPermissions = (
  permissions: AuPolicy[]
): Record<AuResourceName, CrudPermissions> => {
  return {
    dashboard: getPermissions("dashboard", permissions),
    examples: getPermissions("examples", permissions),
    users: getPermissions("users", permissions),
    conversion: getPermissions("conversion", permissions),
    "conversion-filter": getPermissions("conversion-filter", permissions),
    "conversion-output-stream": getPermissions(
      "conversion-output-stream",
      permissions
    ),
    "conversion-output-stream-consumption-event": getPermissions(
      "conversion-output-stream-consumption-event",
      permissions
    ),
    "paid-source": getPermissions("paid-source", permissions),
    retainer: getPermissions("retainer", permissions),
    "tracked-call": getPermissions("tracked-call", permissions),
    "tracked-url": getPermissions("tracked-url", permissions),
    "funnel-stage": getPermissions("funnel-stage", permissions),
    "funnel-stage-assignment": getPermissions(
      "funnel-stage-assignment",
      permissions
    ),
    "custom-tracking-param": getPermissions(
      "custom-tracking-param",
      permissions
    ),
    "conversion-input-stream": getPermissions(
      "conversion-input-stream",
      permissions
    ),
  };
};
